import React from 'react'

const Tag = props => (
  <svg width='1em' height='1em' viewBox='-1 -1 24 24' {...props}>
    <path d='M24 10.605V0H13.391L0 13.391 10.604 24 24 10.605zm-6.414-4.191a2 2 0 1 1 2.827-2.828 2 2 0 0 1-2.827 2.828z' />
  </svg>
)

export default Tag
